import { render, staticRenderFns } from "./PaymentMethods copy 2.vue?vue&type=template&id=1dfb1def&scoped=true"
import script from "./PaymentMethods copy 2.vue?vue&type=script&lang=js"
export * from "./PaymentMethods copy 2.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethods copy 2.vue?vue&type=style&index=0&id=1dfb1def&prod&lang=css"
import style1 from "./PaymentMethods copy 2.vue?vue&type=style&index=1&id=1dfb1def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb1def",
  null
  
)

export default component.exports